import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import FormFields from '../../../../../themes/admin/Fields/FormFields';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const LicensePlateFee = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Row gutter={[16, 16]}>
            <>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.licensePlateFeeMin', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="licensePlateFee.min"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.licensePlateFeeMax', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="licensePlateFee.max"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.licensePlateFeeStep', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="licensePlateFee.step"
                        precision={0}
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <FormFields.InputNumberField
                        {...t('financeProductDetails:fields.licensePlateFeeDefault', { returnObjects: true })}
                        disabled={disabled}
                        min={0}
                        name="licensePlateFee.default"
                        precision={0}
                        required
                    />
                </Col>
            </>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.licensePlateFeeViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="licensePlateFee.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.licensePlateFeeEditable', { returnObjects: true })}
                    disabled={disabled}
                    name="licensePlateFee.isEditable"
                />
            </Col>
        </Row>
    );
};

export default LicensePlateFee;
